import dayjs from 'dayjs';

/**
 * Checks if a date value includes a time component.
 */
function hasTimeComponent(value: unknown): boolean {
  if (value instanceof Date) {
    const hours = value.getHours();
    const minutes = value.getMinutes();
    const seconds = value.getSeconds();
    return hours !== 0 || minutes !== 0 || seconds !== 0;
  }

  if (typeof value === 'string') {
    return value.includes('T');
  }

  return false;
}

interface DateCellProps {
  value: unknown;
}

/**
 * Renders a date value as a locale-formatted string.
 * Includes time if the value has a time component.
 */
export function DateCell({ value }: DateCellProps) {
  const parsed = dayjs(value as string | Date);

  if (!parsed.isValid()) {
    return <span>{String(value)}</span>;
  }

  const format = hasTimeComponent(value) ? 'MMM D, YYYY h:mm A' : 'MMM D, YYYY';
  return <span>{parsed.format(format)}</span>;
}
